import {
    CENTRAL_DATA_MANAGEMENT_MICROSERVICE,
    CANDIDATE_MICROSERVICE,
    COMPANY_MICROSERVICE,
    IDENTITY_MANAGER_MICROSERVICE,
    AJ_WEB_CONNECTOR,
  } from "Constants";
  import type { NavItem, Filters } from "./Interface";
  
  export const NAV_ITEMS: NavItem[] = [
    { label: "Candidate Creation", fieldName: "microservice", value: CANDIDATE_MICROSERVICE },
    { label: "Central Data Management", fieldName: "microservice", value: CENTRAL_DATA_MANAGEMENT_MICROSERVICE },
    { label: "Company Creation", fieldName: "microservice", value: COMPANY_MICROSERVICE },
    { label: "Identity Manager", fieldName: "microservice", value: IDENTITY_MANAGER_MICROSERVICE },
    { label: "Web Connector", fieldName: "microservice", value: AJ_WEB_CONNECTOR },
  ];
  
  export const INITIAL_FILTERS: Filters = {
    searchTerm: "",
    logLevel: "all",
    currentPage: 1,
    recordsPerPage: 10
  };